import * as Sentry from '@sentry/browser';
import { Injectable, ErrorHandler } from '@angular/core';
import { environment } from 'src/environments/environment';

const { sentry } = environment;

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    if (sentry.enabled) {
      const eventId = Sentry.captureException(error.originalError || error);

      if (sentry.showDialog) {
        Sentry.showReportDialog({ eventId });
      }
    }

    throw error;
  }
}
